import { makeApiCall } from "../apiRequest";

export default {
  state: {
    roleList: [],
  },
  getters: {
    getRoleList: (state) => state.roleList,
  },
  actions: {
    async getRoleList({ commit }, payload) {
      const response = await makeApiCall(
        `role/getAll?isAdmin=${payload}`,
        "POST"
      );
      if (!response.error) {
        commit("setRoleList", response.data.data);
      }
      return response;
    },
  },
  mutations: {
    setRoleList(state, payload) {
      state.roleList = payload;
    },
  },
};
